module.exports = __webpack_public_path__ + "static/img/gifted1.a963bb25.png";